import { Component, Input } from '@angular/core';

/**
 * Wrapper de compatibilidade: fio de orçamento via componente genérico.
 */
@Component({
  selector: 'app-budget-comments',
  template: `
    <app-collaboration-comments
      entityType="Budget"
      [entityId]="budgetId"
      [allowInternal]="true"
      emptyLabel="Nenhum comentário neste orçamento.">
    </app-collaboration-comments>
  `
})
export class BudgetCommentsComponent {
  @Input() budgetId: number | null = null;
}
